import { hasNFCSupport, parseHex } from './utils';

export const nfcScan = async ({ onDetect, onError }: any) => {
    if (!hasNFCSupport()) {
        return false;
    }

    const errorListener = () => {
        onError('Cannot read data from the NFC tag. Try another one?');
    };

    const readingListener = ({ serialNumber }: any) => {
        onDetect(parseHex(serialNumber));
    };

    const ndef = new NDEFReader();
    const abortController = new AbortController();

    try {
        await ndef.scan({ signal: abortController.signal });
        ndef.addEventListener('readingerror', errorListener);
        ndef.addEventListener('reading', readingListener);
    } catch (error: any) {
        onError(error.message);
    }

    // this is for the useEffect hook to remove event listeners
    return () => {
        ndef.removeEventListener('readingerror', errorListener);
        ndef.removeEventListener('reading', readingListener);
        abortController.abort();
    };
};
